<template>
  <div>
    <div class="card ml-3 card-information-style">
      <div class="">
        <div
          class="circle-section-image"
          :class="showActions ? 'pt-2' : 'pt-10'"
        >
          <div
            v-if="showActions && !getHasPerformanceIntegration"
            class="more-settings d-flex align-self-end position-relative c-pointer"
            role="group"
          >
            <div
              class="flaticon-more"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            ></div>
            <div class="dropdown-menu mt-2" aria-labelledby="btnGroupDrop1">
              <button v-if="isActionAllowed(96)" @click="resetPass('#resetModal')"
                class="dropdown-item d-flex align-items-center c-pointer" data-vs-button="reset-password">
                <i class="icon-ResetPass icon-style m-0 p-0 pr-2" style="top: auto"></i>
                <span>{{ $t('message.search_reset_pass_tooltip') }}</span>
              </button>
              <button v-if="!hasIntegration('rex') && state === 2" @click="openModal('#changeTemplate')"
                class="dropdown-item d-flex align-items-center c-pointer" data-vs-button="change-temp">
                <i style="font-size: 24px" class="icon-style m-0 p-0 pr-2 icon-Refresh"></i>
                <span>{{ $t('message.ob_change_template_tooltip') }}</span>
              </button>
              <button v-if="state === 3" class="dropdown-item d-flex align-items-center c-pointer"
                @click="openModal('#reactivateUser')" data-vs-button="reactive-user">
                <i style="font-size: 24px" class="icon-style m-0 p-0 pr-2">
                  <svg width="25" height="19" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.2098 11.98C15.5098 11.98 18.1998 9.28999 18.1998 5.98999C18.1998 2.67999 15.5098 0 12.2098 0C8.90978 0 6.21975 2.68999 6.21975 5.98999C6.20975 9.28999 8.89978 11.98 12.2098 11.98ZM12.2098 0.98999C14.9598 0.98999 17.1998 3.23001 17.1998 5.98001C17.1998 8.73001 14.9598 10.97 12.2098 10.97C9.45977 10.97 7.21975 8.73001 7.21975 5.98001C7.20975 3.23001 9.44977 0.98999 12.2098 0.98999Z"
                      fill="#4F41A3" />
                    <path
                      d="M20.78 11.69C19.18 11.69 17.7 12.23 16.51 13.12C15.16 12.61 13.71 12.33 12.21 12.33C6.40002 12.33 1.32 16.45 0.130005 22.14L0 22.74H14.78C16.06 24.7 18.27 26 20.77 26C24.72 26 27.93 22.79 27.93 18.84C27.93 14.89 24.73 11.69 20.78 11.69ZM1.25 21.74C2.56 16.83 7.07002 13.33 12.21 13.33C13.4 13.33 14.55 13.53 15.64 13.88C14.39 15.17 13.62 16.92 13.62 18.85C13.62 19.88 13.84 20.86 14.24 21.75H1.25V21.74ZM20.78 25C18.86 25 17.15 24.12 16.02 22.74C15.77 22.43 15.54 22.1 15.35 21.74C14.89 20.88 14.62 19.89 14.62 18.84C14.62 17.02 15.42 15.39 16.68 14.26C16.96 14.01 17.27 13.78 17.59 13.58C18.52 13.01 19.61 12.68 20.78 12.68C24.18 12.68 26.94 15.44 26.94 18.84C26.94 22.24 24.18 25 20.78 25Z"
                      fill="#4F41A3" />
                    <path
                      d="M24.7101 16.42L24.4501 16.16C24.3301 16.04 24.1101 16.04 23.9701 16.16C22.6101 17.54 21.2501 18.91 19.8901 20.28C19.1701 19.54 18.4501 18.82 17.7201 18.09C17.5901 17.96 17.3701 17.96 17.2401 18.09C17.1501 18.18 17.0801 18.26 16.9901 18.35C16.8601 18.47 16.8601 18.69 16.9901 18.83L19.5401 21.4C19.8301 21.69 19.9601 21.69 20.2401 21.4C21.7201 19.9 23.2101 18.4 24.7001 16.91C24.8401 16.76 24.8401 16.55 24.7101 16.42Z"
                      fill="#4F41A3" />
                  </svg>
                </i>
                <span>{{ $t('message.ob_reactivate_user') }}</span>
              </button>
              <button v-if="state === 3" class="dropdown-item d-flex align-items-center c-pointer"
                @click="resetPass('#updateUserEmail')" data-vs-button="update-user-email">
                <i style="font-size: 24px" class="icon-style m-0 p-0 pr-2">
                  <zt-icon name="envelop" class="icon-email pl-1" />
                </i>
                <span>{{ $t('message.ob_update_user_email') }}</span>
              </button>

              <button v-if="(!hasIntegration('rex') && (state === 1 || state === 2) && isActionAllowed(95))"
                class="dropdown-item d-flex align-items-center c-pointer"
                @click="openModal('#unsubscribeConfirmationModal')" data-vs-button="unsubscribe-confirm-modal">
                <i style="font-size: 24px" class="icon-style m-0 p-0 pr-2 icon-Fire"></i>
                <span>{{ $t('message.ei_personal_employee_unlink') }}</span>
              </button>
            </div>
          </div>
          <!-- Placeholder vacío cuando hay integración Performance -->
          <div
            v-else-if="showActions && getHasPerformanceIntegration"
            class="more-settings d-flex align-self-end"
          >
            <div class="flaticon-more invisible"></div>
          </div>
          <div class="modal fade" id="resetModal" role="dialog">
            <ResetPass @mailChanged="mailChanged" :email="mailUser" :automaticKey="automaticKey"></ResetPass>
          </div>
          <div class="modal fade" id="changeTemplate" role="dialog">
            <ChangeTemplate :templateId="templateId" :setTemplateChanged="setTemplateChanged" />
          </div>
          <div class="modal fade" id="reactivateUser" role="dialog">
            <ReactivateUser :templateId="templateId" :unsubscribeDate="historyUnsubscribe.unsubscribeDate"
              @isReactivateUser="isUnsubscribed" :setTemplateChanged="setTemplateChanged" />
          </div>
          <div class="modal fade" id="updateUserEmail" role="dialog">
            <UpdateUserEmail :email="mailUser" @mailChanged="mailChanged" />
          </div>
          <div class="modal fade bd-example-modal-md" id="unsubscribeConfirmationModal" role="dialog">
            <UnsubscribeConfirmation ref="unsubscribeConfirmation" @isUnsubscribed="isUnsubscribed"
              class="position-relative"></UnsubscribeConfirmation>
          </div>
          <div class="avatar-container">
            <div class="employee-status-circle" :class="[
              state === 1
                ? 'employee-status-circle-active'
                : state === 2
                  ? 'employee-status-circle-onboarding'
                  : state === 3
                    ? 'employee-status-circle-inactive'
                    : 'employee-status-circle-default'
            ]"></div>
            <div v-if="imgAvatar && typeof imgAvatar === 'string' && imgAvatar.trim() !== '' && imgAvatar !== 'null' && imgAvatar !== 'undefined' && !imgAvatar.includes('img-not-found')">
              <img :src="imgAvatar" class="imageCorrection" @error="handleImgError" />
            </div>
            <div v-else class="userpic">
              {{ shortname || defaultInitials }}
            </div>
          </div>
          <div class="personal-data-section">
            <div class="d-flex align-items-baseline">
              <div class="name-section text-uppercase" :title="nombre">{{ nombre }}</div>
              <div v-if="rh === null && humanResources === true" class="ml-2 employee-type-style">
                {{ $t('message.userActive.human_resources') }}
              </div>
              <div v-else-if="rh === true" class="ml-2 employee-type-style">
                {{ $t('message.userActive.human_resources') }}
              </div>
            </div>
            <div v-if="cuil && (country === 'BO' || country === 'PY')" class="cuil-section">
              {{ $t('message.userActive.dni') }}: {{ cuil }}
            </div>
            <div v-else-if="cuil" class="cuil-section">
              {{ $t('message.userActive.cuil') }}: {{ cuil }}
            </div>
            <div class="startdate-section">
              <div v-if="state === 1">
                {{ $t('message.userActive.estado') }}:
                {{ $t('message.userActive.activo') }}
              </div>
              <div v-else-if="state === 2">
                {{ $t('message.userActive.estado') }}:
                {{ $t('message.userActive.onboarding') }}
              </div>
              <div v-else-if="state === 3">
                {{ $t('message.userActive.estado') }}:
                {{ $t('message.userActive.inactivo') }}
              </div>
            </div>
            <div class="startdate-section flex" v-if="state === 3 && historyUnsubscribe.show">
              <span class="mt-auto">{{ $t('message.unsubscribe.confirm_unsubscribe_why_title') }}:
                {{ historyUnsubscribe.reason }}</span>
              <zt-tooltip v-bind:text="$t('message.unsubscribe.confirm_unsubscribe_observation') +
                ' : ' +
                (historyUnsubscribe.observations
                  ? historyUnsubscribe.observations
                  : '---')
                " v-bind:title="$t('message.unsubscribe.date') +
                  ' : ' +
                  (historyUnsubscribe.unsubscribeDate
                    ? historyUnsubscribe.unsubscribeDate
                    : '---')
                  " position="bottom" color="primary" outlined>
                <zt-icon name="info-circle-alt text-zt-lg cursor-pointer" />
              </zt-tooltip>
            </div>
            <div v-if="state === 2 && onboardingProcess" class="w-100" style="max-width: 150px">
              <transition name="fade" mode="out-in">
                <div class="d-flex flex-column">
                  <PercentBars class="mb-3 mt-2" :percent="percent"></PercentBars>
                  <button class="btn btn-secondary" style="width: 100% !important" :disabled="requestAPILoading"
                    @click.prevent="activeOnb" data-vs-button="active-ob">
                    {{ $t('message.ei_ActiveButton') }}
                  </button>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <div class="card-body card-sections">
          <div v-show="false">{UserOption{hasChangedDate}}</div>
          <div v-for="item in sectionsTitles">
            <UserOption :item="item" @changeSection="changeSection"></UserOption>
          </div>
        </div>
      </div>
    </div>
    <zt-modal :active="showActiveOnbAlert" @close="showActiveOnbAlert = false" :show-button-close="false"
      max-width="400px" z-index="9999">
      <template #modal-header>
        <div class="rounded pl-4 py-2 bg-zt-primary-200">
          <span class="text-white text-zt-base font-medium">
            {{ $t('message.employeePanel.onboardingActivate') }}
          </span>
        </div>
      </template>
      <div class="flex items-center">
        <div class="p-4">
          <div class="h-20 w-20 rounded-full bg-red-400 flex justify-center items-center">
            <span class="alert--icon text-white"><zt-icon name="times" /></span>
          </div>
        </div>
        <div class="text-zt-dark-400 font-medium">
          <template v-if="errorData.length === 1">
            <p class="pt-4 pr-4 text-wrap">
              {{ $t('message.employeePanel.errorDoc') }}
              {{ hasDocumentsErrors }}.
            </p>
            <p class="py-4">{{ $t('message.employeePanel.requestDoc') }}</p>
          </template>
          <template v-else>
            <p class="pt-4 text-wrap">
              {{ $t('message.employeePanel.errorDocMultiple') }}
              {{ hasDocumentsErrors }}.
            </p>
            <p class="py-4">
              {{ $t('message.employeePanel.requestDocMultiple') }}
            </p>
          </template>
        </div>
      </div>
      <template #modal-footer>
        <div class="p-4 bg-zt-dark-200">
          <div class="w-full flex items-end">
            <div class="ml-auto">
              <button class="font-medium btn--outlined text-zt-dark-400 focus:outlined-none pr-4"
                @click="showActiveOnbAlert = false" data-vs-button="shown-modal">
                {{ $t('message.employeePanel.buttonCancel') }}
              </button>
              <zt-button data-vs-button="send-request" @click="sendRequestDoc" :disabled="disabledSendRequestDoc">
                <span class="font-medium">
                  {{ $t('message.employeePanel.buttonRequest') }}
                </span>
              </zt-button>
            </div>
          </div>
        </div>
      </template>
    </zt-modal>
  </div>
</template>
<script>
import ResetPass from '../useram/ResetPassUser'
import ReactivateUser from './ReactivateUser'
import UnsubscribeConfirmation from '../useram/UnsubscribeConfirmation'
import UserOption from '../useram/UserOption'
import ChangeTemplate from './ChangeTemplate'
import UpdateUserEmail from './UpdateUserEmail'
import Users from '../../../apiClient/User'
import UserManagement from '../../../apiClient/UserManagement'
import Employee from '../../../apiClient/Employee'
import Onboarding from '../../../apiClient/OnBoarding'
import Search from '../../../apiClient/Search'
import PercentBars from '../../generics/PercentBars'
import { mapGetters } from 'vuex'
import { map, isEmpty, reduce } from 'lodash'
import moment from 'moment'
import { hasIntegration } from '@/utils/getIntegrations'

export default {
  components: {
    ResetPass,
    PercentBars,
    ChangeTemplate,
    UnsubscribeConfirmation,
    ReactivateUser,
    UserOption,
    UpdateUserEmail
  },
  props: {
    fecha: String,
    cuil: String,
    rh: Boolean,
    nombre: String,
    hasChanged: String,
    setTemplateChanged: Function,
    resetData: Boolean
  },
  data() {
    return {
      employeeState: [
        {
          id: 1,
          value: 'Activo'
        },
        {
          id: 2,
          value: 'Onboarding'
        },
        {
          id: 3,
          value: 'Inactivo'
        }
      ],
      sectionsTitles: [
        {
          id: 0,
          name: this.$t('message.userActive.title_menu_onboarding'),
          icon: 'icon-Statics',
          show: false,
          hasOnboarding: false,
          checkForDisable: false,
          hasPermission: true
        },
        {
          id: 1,
          name: this.$t('message.userActive.title_menu_personal_info'),
          icon: 'icon-Person',
          show: false,
          hasOnboarding: false,
          checkForDisable: false,
          hasPermission: true
        },
        {
          id: 4,
          name: this.$t('message.userActive.title_menu_configuration'),
          icon: 'icon-Config',
          show: false,
          hasOnboarding: false,
          checkForDisable: true,
          hasPermission: true
        }
      ],
      imgAvatar: '',
      templateId: 0,
      state: 0,
      shortname: '',
      nameAvatar: '',
      lastnameAvatar: '',
      profilesCompany: [],
      companyId: 0,
      automaticKey: false,
      cuilEP: 0,
      humanResources: false,
      startDate: '',
      percent: 0,
      country: '',
      requestAPILoading: false,
      mailUser: '',
      onboardingProcess: false,
      historyUnsubscribe: {
        show: false,
        reason: '',
        observations: '',
        unsubscribeDate: ''
      },
      showActiveOnbAlert: false,
      errorData: [],
      disabledSendRequestDoc: false
    }
  },
  created() {
    this.$store.dispatch('setInitialOnBoardingList')
    this.ob = new Employee()
    this.op = new Onboarding()
    this.search = new Search()
    this.userClientNew = new UserManagement()
    this.usersProfile = new Users()
    this.getAvatar()
    this.getEmployeeById()
    this.getUserInformation(this.$route.params.id)
    this.getIdCompany()
    this.setPermissions()
  },
  computed: {
    ...mapGetters({
      getActivateDate: 'getActivateDate',
      isActionAllowed: 'isActionAllowed',
      hasIntegration: 'hasIntegration',
      hasAnyIntegration: 'hasAnyIntegration',
      getHasPerformanceIntegration: "getHasPerformanceIntegration",
    }),
    showActions() {
      return this.isActionAllowed(96) ||
        this.state === 2 ||
        this.state === 3 ||
        ((this.state === 1 || this.state === 2) && this.isActionAllowed(95))
        ? true
        : false
    },
    hasChangedDate() {
      if (this.getActivateDate === true) {
        this.changeSection(this.sectionsTitles[1])
      }
      return this.getActivateDate
    },
    defaultInitials() {
      if (this.shortname && typeof this.shortname === 'string' && this.shortname.trim() !== '') {
        return this.shortname.trim().toUpperCase()
      }
      if (this.nameAvatar || this.lastnameAvatar) {
        const first = this.nameAvatar && typeof this.nameAvatar === 'string' ? this.nameAvatar.trim().charAt(0) : ''
        const last = this.lastnameAvatar && typeof this.lastnameAvatar === 'string' ? this.lastnameAvatar.trim().charAt(0) : ''
        if (first || last) {
          return (first + last).toUpperCase()
        }
      }
      if (this.nombre && typeof this.nombre === 'string' && this.nombre.trim() !== '') {
        const parts = this.nombre.trim().split(/\s+/)
        const first = parts[0] ? parts[0].charAt(0) : ''
        const last = parts.length > 1 && parts[parts.length - 1] ? parts[parts.length - 1].charAt(0) : ''
        return (first + last).toUpperCase()
      }
      return 'US'
    },
    hasDocumentsErrors() {
      if (!isEmpty(this.errorData)) {
        const aliases = map(this.errorData, (error) => error.alias)
        if (aliases.length > 1) {
          return reduce(
            aliases,
            (message, alias, key) => {
              if (key === 0) {
                return `${alias}`
              }
              if (key + 1 === aliases.length) {
                return `${message} y ${alias}`
              }
              return `${message}, ${alias}`
            },
            ''
          )
        }

        return aliases.join()
      }

      return null
    }
  },
  methods: {
    openModal(target) {
      if (!target) return
      $(target).modal('show')
    },
    closeModal(target) {
      $(target).modal('hide')
    },
    searchStatistics(id) {
      this.op
        .getStatistics(id)
        .then((res) => {
          if (res.status === 200 && res.data && res.data[0]) {
            let itemsObligatoriosTotales = 0
            let itemsObligatoriosCompletos = 0
            itemsObligatoriosTotales = res.data[0].items_obligatorios_totales || 0
            itemsObligatoriosCompletos =
              res.data[0].items_obligatorios_completos || 0
            if (itemsObligatoriosTotales > 0) {
              this.percent =
                (itemsObligatoriosCompletos / itemsObligatoriosTotales) * 100
            } else {
              this.percent = 0
            }
          }
        })
        .catch((error) => { })
    },
    getEmployeeById() {
      this.ob
        .getEmployeeById(this.$route.params.id)
        .then((result) => {
          if (result.status === 200 && result.data && result.data[0]) {
            let nameOnboarding =
              result.data[0].nombre + '' + result.data[0].apellido
            this.sectionsTitles[0].hasOnboarding = true
            this.sectionsTitles[1].hasOnboarding = true
            this.sectionsTitles[2].hasOnboarding = true
            this.onboardingName(nameOnboarding)
            this.startDate = moment(result.data[0].fecha_alta).format(
              'DD/MM/YYYY'
            )
            this.searchStatistics(this.$route.params.id)
            this.templateId = result.data[0].id_company_template
          } else {
            this.sectionsTitles[0].hasOnboarding = false
          }
        })
        .catch((error) => {
          if (error.response && (error.response.status === 404 || error.response.status === 400)) {
            this.sectionsTitles[0].hasOnboarding = false
          }
        })
    },
    getUserInformation(id) {
      this.usersProfile
        .getinfoEmployee(id)
        .then((res) => {
          if (res.status === 200 && res.data) {
            let response = res.data
            this.nameAvatar = response.nombre || response.name || (this.nombre ? this.nombre.split(' ')[0] : '') || ''
            this.lastnameAvatar = response.apellido || response.lastname || (this.nombre && this.nombre.split(' ').length > 1 ? this.nombre.split(' ').slice(-1)[0] : '') || ''
            if (this.nameAvatar || this.lastnameAvatar) {
              const firstChar = typeof this.nameAvatar === 'string' && this.nameAvatar ? this.nameAvatar.trim().charAt(0) : ''
              const lastChar = typeof this.lastnameAvatar === 'string' && this.lastnameAvatar ? this.lastnameAvatar.trim().charAt(0) : ''
              this.shortname = (firstChar + lastChar).toUpperCase()
            } else if (this.nombre && typeof this.nombre === 'string' && this.nombre.trim() !== '') {
              const parts = this.nombre.trim().split(/\s+/)
              const firstChar = parts[0] ? parts[0].charAt(0) : ''
              const lastChar = parts.length > 1 && parts[parts.length - 1] ? parts[parts.length - 1].charAt(0) : ''
              this.shortname = (firstChar + lastChar).toUpperCase()
            } else {
              this.shortname = ''
            }
            if (response.estado_empresa === 1) {
              this.state = 1
              this.$emit('refreshInfoEmployee', response)
              this.sectionsTitles[0].show = false
              this.sectionsTitles[1].show = true
              this.sectionsTitles[1].hasOnboarding = true
              this.sectionsTitles[2].hasOnboarding = true
            }
            if (response.estado_empresa === 2) {
              this.state = 2
              this.onboardingProcess = true
              this.sectionsTitles[0].show = true
              this.sectionsTitles[0].hasOnboarding = true
              this.sectionsTitles[1].show = false
            }

            this.historyUnsubscribe.show = false
            if (response.estado_empresa === 3) {
              this.state = 3
              this.historyUnsubscribe.show = true
              this.historyUnsubscribe.reason = response.motivo_baja
              this.historyUnsubscribe.observations = response.observaciones
                ? response.observaciones
                : '---'
              this.historyUnsubscribe.unsubscribeDate = response.fecha_baja
                ? response.fecha_baja
                : '---'
              this.sectionsTitles[1].show = true
              this.sectionsTitles[1].hasOnboarding = true
              this.sectionsTitles[2].hasOnboarding = true
            }

            this.$emit('stateEmployee', this.state)
          }
        })
        .catch((error) => { })
    },
    getIdCompany() {
      this.$store
        .dispatch('getProfile')
        .then((res) => {
          this.country = res.pais
          this.companyId = res.empresa.id
          this.$emit('companyCountry', this.country)
          this.getProfileCompany(this.companyId)
        })
        .catch((error) => { })
    },
    getProfileCompany(id) {
      this.userClientNew
        .getProfileCompany(id)
        .then((res) => {
          if (res.status === 200) {
            this.profilesCompany = res.data
            let index = 0
            this.profilesCompany.forEach((element) => {
              if (index < 1) this.profilesCompany.splice(0, 1)
              index++
            })
            this.getUserConfiguration(id)
          }
        })
        .catch((error) => { })
    },
    getUserConfiguration(id) {
      this.userClientNew
        .getProfilesUser(this.$route.params.id)
        .then((res) => {
          if (res.status === 200) {
            let profiles = res.data.perfiles
            profiles.forEach((element) => {
              this.profilesCompany.map((profile) => {
                if (element.idperfil == profile.id) {
                  if (profile.id_perfil_tipo != 1) {
                    this.humanResources = true
                  }
                }
              })
            })
          }
        })
        .catch((error) => { })
    },
    changeSection(item) {
      for (let index = 0; index < this.sectionsTitles.length; index++) {
        this.sectionsTitles[index].show =
          item.id === this.sectionsTitles[index].id
      }
      this.$emit('menuToSections', this.sectionsTitles)
      window.scrollTo(0, 0)
    },
    getAvatar() {
      this.usersProfile
        .getAvatar(this.$route.params.id)
        .then((res) => {
          if (
            res.status === 200 &&
            res.data &&
            typeof res.data === 'string' &&
            res.data.trim() !== '' &&
            res.data !== 'null' &&
            res.data !== 'undefined' &&
            !res.data.includes('img-not-found')
          ) {
            this.imgAvatar = res.data
          } else {
            this.imgAvatar = ''
          }
        })
        .catch((error) => {
          this.imgAvatar = ''
        })
    },
    handleImgError() {
      this.imgAvatar = ''
    },
    resetPass(modalName) {
      this.openModal(modalName)
      this.usersProfile
        .getinfoEmployee(this.$route.params.id)
        .then((res) => {
          if (res.status === 200) {
            this.mailUser = ''
            this.mailUser = res.data.mail
            if (this.mailUser === undefined) this.automaticKey = false
            else this.automaticKey = true
          }
        })
        .catch((error) => { })
    },
    onboardingName(event) {
      this.$emit('hasOnboarding', event)
    },
    activeOnb(id) {
      this.requestAPILoading = true
      swal({
        title: this.$t('message.ob_submit_swal_title_eactivate').toString(),
        text: this.$t('message.ob_submit_swal_text').toString(),
        type: 'warning',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: '#54CAA6',
        confirmButtonText: this.$t('message.ob_submit_swal_confirm').toString(),
        cancelButtonText: this.$t('message.ob_submit_swal_reject').toString(),
        cancelButtonColor: '#ffffff'
      }).then((result) => {
        if (result.value) {
          this.search.Aprove(this.$route.params.id).then(
            (res) => {
              if (res.status == 200) {
                swal({
                  type: 'success',
                  title: 'Ok',
                  text: this.$t('message.employee_edit_success').toString(),
                  showConfirmButton: true,
                  confirmButtonText: this.$t(
                    'message.billboard_form_post_button_confirm'
                  ).toString()
                }).then(() => {
                  if (this.getHasPerformanceIntegration) {
                    this.$router.push('/employees/list');
                  } else {
                    this.state = 1;
                    this.$emit("userActiveOnb");
                    this.requestAPILoading = false;
                    this.onboardingProcess = false;
                    this.getEmployeeById();
                  }
                });
              }
              if (res.status == 201) {
                swal({
                  type: 'success',
                  title: this.$t(
                    'message.sichernIntegrations.activateOnboarding.success.title'
                  ),
                  text: this.$t(
                    'message.sichernIntegrations.activateOnboarding.success.info'
                  ),
                  showConfirmButton: true
                }).then(() => {
                  if (this.getHasPerformanceIntegration) {
                    this.$router.push('/employees/list');
                  } else {
                    this.state = 1;
                    this.$emit("userActiveOnb");
                    this.requestAPILoading = false;
                    this.onboardingProcess = false;
                    this.getEmployeeById();
                  }
                });
              }
            },
            (error) => {

              this.requestAPILoading = false

              let msg

              const knowCodes = ['50010', '05006', '50004']
              const sichernMediatorErrorCodes = [
                'SICHERN_PEOPLE_INVALID_POST_VALUES_MEDIATOR',
                'SICHERN_PEOPLE_MEDIATOR',
                'EXTERNAL_API_COULD_NOT_CONNECT',
                'SICHERN_PEOPLE_POST_MEDIATOR_BAD_REQUEST',
                'SICHERN_PEOPLE_PUT_MEDIATOR_BAD_REQUEST'
              ]
              const performanceErrorCodes = [
                "PERFORMANCE_CONFIGURATION_ERROR",
                "PERFORMANCE_VALIDATION",
                "PERFORMANCE_AUTHENTICATION_ERROR",
                "PERFORMANCE_SEND_DATA_ERROR",
                "PERFORMANCE_UNEXPECTED_ERROR"
              ]
              const rexErrorCodes = {
                REX_UNEXPECTED_ERROR: 'message.rexIntegrations.errors.REX_UNEXPECTED_ERROR',
                EXTERNAL_API_REX_REQUEST_ERROR: 'message.rexIntegrations.errors.EXTERNAL_API_REX_REQUEST_ERROR',
                SYSTEM_ONBOARDING_ENTITY_ID_NOT_FOUND: 'message.rexIntegrations.errors.SYSTEM_ONBOARDING_ENTITY_ID_NOT_FOUND'
              }
              const data = (error.response && error.response.data) ? error.response.data : {}
              if (data.code && data.code.toString() === '50010') {
                const { data: innerData } = data
                this.showActiveOnbAlert = true
                return (this.errorData = [...innerData])
              } else if (
                data.code &&
                data.code.toString() === 'SICHERN_PEOPLE_VALIDATION'
              ) {
                const { data: innerData } = data
                let html = `<p>${this.$t(
                  'message.sichernIntegrations.activateOnboarding.validations.modal_subtitle'
                )}</p><br><ul style="list-style-type:disc;width: 60%;margin: auto;text-align: left;">`
                for (const item of innerData.messages) {
                  html += `<li>${this.$t(
                    'message.sichernIntegrations.activateOnboarding.validations.' + item
                  )}</li>`
                }
                html += `</ul>`
                swal({
                  type: 'warning',
                  title: this.$t(
                    'message.sichernIntegrations.activateOnboarding.validations.modal_title'
                  ),
                  html: html,
                  showConfirmButton: true
                })
                return
              } else if (
                data.code &&
                sichernMediatorErrorCodes.includes(data.code.toString())
              ) {
                this.mediatorMessage(data.data)
                return
              } else if (data.code && performanceErrorCodes.includes(data.code.toString())) {
                this.performanceMessage(error.response.data)
                return
              } else {
                if (Array.isArray(data.codes) && data.codes.length) {
                  const first = data.codes[0].code
                  const translationKey = rexErrorCodes[first]

                  if (translationKey) {
                    msg = this.$t(translationKey)
                  } 
                  else {
                    msg = data.codes
                      .map(c => c && c.message)
                      .filter(Boolean)
                      .join('\n')
                  }
                } else if (data.hasOwnProperty('results')) {
                  msg = data.results.data[0]
                } else if (data.code) {
                  msg = this.$t('message.error_' + data.code)
                } else {
                  msg = this.$t('message.rexIntegrations.errors.default_error')
                }
              }


              swal({
                type: 'error',
                title: 'Error',
                text: msg,
                showConfirmButton: false
              })
            }
          )
        } else {
          this.requestAPILoading = false
        }
      })
    },
    mediatorMessage(data) {
      const { messages } = data
      const mediatorCustomMessage = [
        'EmployeeFoundWithSameDocumentAndSameFileNumber',
        'EmployeeNotFoundWithFileNumberAndDocumentNumber',
        'FileNumberExists',
        'EmployeeNotFound',
        'InvalidDocumentIdentifier'
      ]

      let outputMessage = this.$t(
        'message.sichernIntegrations.activateOnboarding.errors.generic'
      )

      if (mediatorCustomMessage.includes(messages[0])) {
        outputMessage = this.$t(
          'message.sichernIntegrations.activateOnboarding.errors.' + messages[0]
        )
      }

      swal({
        type: 'error',
        title: outputMessage,
        showConfirmButton: true
      })
    },
    performanceMessage(errorData) {
      const { code, data } = errorData
      const performanceErrorMap = {
        'PERFORMANCE_CONFIGURATION_ERROR': {
          type: 'error',
          title: this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_CONFIGURATION_ERROR.title"),
          text: this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_CONFIGURATION_ERROR.description")
        },
        'PERFORMANCE_VALIDATION': {
          type: 'warning',
          title: this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_VALIDATION.title"),
          text: this.getPerformanceValidationMessage(data)
        },
        'PERFORMANCE_AUTHENTICATION_ERROR': {
          type: 'error',
          title: this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_AUTHENTICATION_ERROR.title"),
          text: this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_AUTHENTICATION_ERROR.description"),
          confirmButtonText: this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_AUTHENTICATION_ERROR.retry")
        },
        'PERFORMANCE_SEND_DATA_ERROR': {
          type: 'error',
          title: this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_SEND_DATA_ERROR.title"),
          text: data && data.message ? data.message : this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_SEND_DATA_ERROR.description")
        },
        'PERFORMANCE_UNEXPECTED_ERROR': {
          type: 'error',
          title: this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_UNEXPECTED_ERROR.title"),
          text: this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_UNEXPECTED_ERROR.description")
        }
      };

      const errorConfig = performanceErrorMap[code] || {
        type: 'error',
        title: 'Error',
        text: this.$t("message.performanceIntegrations.activateOnboarding.errors.generic")
      };

      swal({
        type: errorConfig.type,
        title: errorConfig.title,
        text: errorConfig.text,
        showConfirmButton: true,
        confirmButtonText: errorConfig.confirmButtonText || this.$t("message.billboard_form_post_button_confirm")
      });
    },
    getPerformanceValidationMessage(data) {
      if (!data || !data.fields || !Array.isArray(data.fields) || data.fields.length === 0) {
        return this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_VALIDATION.description")
      }

      let message = this.$t("message.performanceIntegrations.activateOnboarding.errors.PERFORMANCE_VALIDATION.description") + "\n\n"

      data.fields.forEach(field => {
        message += `• ${field}\n`
      })

      return message
    },
    mailChanged(value) {
      this.$emit('mailChanged', value)
    },
    isUnsubscribed(value) {
      this.$refs.unsubscribeConfirmation.unsubscribe.observations = ''
      this.getUserInformation(this.$route.params.id)
    },
    setPermissions() {
      this.sectionsTitles[1].hasPermission = !this.getHasPerformanceIntegration;
      this.sectionsTitles[2].hasPermission = this.isActionAllowed(94) && !this.getHasPerformanceIntegration;
    },
    async sendRequestDoc() {
      const requestRefuseDoc = []
      const params = { iduser: this.$route.params.id }
      const fields = map(this.errorData, (error) => error.field)
      const imagesName = map(this.errorData, (error) => error.imageName)
      this.disabledSendRequestDoc = true
      await this.ob.deleteImgForEmployee({
        iduser: this.$route.params.id,
        field: fields.join(),
        imageName: imagesName.join()
      })

      this.setTemplateChanged(true)

      this.showActiveOnbAlert = false
      this.disabledSendRequestDoc = false
    }
  },
  watch: {
    nombre(val) {
      if ((!this.shortname || this.shortname.trim() === '') && val && typeof val === 'string' && val.trim() !== '') {
        const parts = val.trim().split(/\s+/)
        const firstChar = parts[0] ? parts[0].charAt(0) : ''
        const lastChar = parts.length > 1 && parts[parts.length - 1] ? parts[parts.length - 1].charAt(0) : ''
        this.shortname = (firstChar + lastChar).toUpperCase()
      }
    },
    resetData(newValue, oldValue) {
      if (newValue) {
        this.getEmployeeById()
      }
    },
    hasChanged: function (val) {
      this.searchStatistics(this.$route.params.id)
    }
  }
}
</script>

<style scoped lang="scss">
@import "./public/assets/scss/components/_usuarioam.scss";

.hidden-disabled {
  visibility: hidden !important;
  pointer-events: none !important;
  cursor: default !important;
}

.menu-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  cursor: default;
}

.more-settings-placeholder {
  position: relative;
  max-height: 35px;
  min-height: 35px;
  margin-top: 5px;
  min-width: 2rem;
  padding: 3px;
  display: flex;
  align-self: flex-end;
}

.btn.btn-default:hover:not(:disabled),
.btn.btn-default.active,
.btn.btn-default:active,
.btn.btn-default:focus,
.show>.btn.btn-default.dropdown-toggle,
.btn.btn-secondary:hover:not(:disabled),
.btn.btn-secondary.active,
.btn.btn-secondary:active,
.btn.btn-secondary:focus,
.show>.btn.btn-secondary.dropdown-toggle {
  border: solid 2px white !important;
  width: 100% !important;
}

.icon-Info:before {
  color: white;
}

.alert--icon {
  font-size: 32px;
  padding: 0 0 6px 0px;
}

.icon-email {
  color: #4f41a3;
  top: 0 !important;

  &:before {
    font-size: 1vw !important;
  }
}

/* Scoped layout styles for circular avatar, initials and header */
.avatar-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.5rem auto 1rem auto;
  width: 11em;
  height: 11em;
  border-radius: 50%;
}

.userpic {
  width: 11em;
  height: 11em;
  border-radius: 50%;
  background: linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%);
  color: #2470A0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.2rem;
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  letter-spacing: 2px;
  box-shadow: 0 4px 15px rgba(36, 112, 160, 0.15);
  border: 4px solid #ffffff;
  user-select: none;
  text-transform: uppercase;
}

.imageCorrection {
  width: 11em !important;
  height: 11em !important;
  border-radius: 50% !important;
  object-fit: cover;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  border: 4px solid #ffffff;
  display: block;
}

.employee-status-circle {
  position: absolute;
  bottom: 8px;
  right: 15px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 3px solid #ffffff;
  z-index: 5;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);

  &-active {
    background-color: #28a745;
  }

  &-onboarding {
    background-color: #ffc107;
  }

  &-inactive {
    background-color: #dc3545;
  }

  &-default {
    background-color: #6c757d;
  }
}

.circle-section-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 1rem;
  width: 100%;
}

.personal-data-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0.5rem 1rem 1.2rem 1rem;
  border-bottom: 1px solid #ebedf2;
  margin-bottom: 1rem;
  width: 100%;

  .d-flex.align-items-baseline {
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
  }

  .name-section {
    font-size: 1.25rem;
    font-weight: 700;
    color: #2e384d;
    margin-bottom: 0.25rem;
    word-break: break-word;
    line-height: 1.3;
    text-align: center;
  }

  .employee-type-style {
    display: inline-flex;
    align-items: center;
    background-color: #e8f4f8;
    color: #2470A0;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.2rem 0.6rem;
    border-radius: 12px;
    margin-top: 0.25rem;
  }

  .cuil-section, .startdate-section {
    font-size: 0.85rem;
    color: #6c757d;
    margin-top: 0.35rem;
    text-align: center;
    width: 100%;
  }
}

.card-information-style {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #eaedf2;
  overflow: hidden;
  padding-bottom: 1rem;
}
</style>
